export { numeric, email, required, url } from '@vuelidate/validators';

const STRONG_PASS_REG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@_#$%^&*?])(?=.{8,})/;

export const strongPassword = (function () {
  // eslint-disable-next-line
  const validators: any = require('@vuelidate/validators');
  return validators.helpers.regex(STRONG_PASS_REG);
})();
